import React from "react";
import PropTypes from "prop-types";

import Griddle, {
  ColumnDefinition,
  RowDefinition,
  plugins,
} from "griddle-react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import tableStyle from "assets/jss/material-dashboard-react/components/tableStyle";

import CardBody from "components/Card/CardBody.jsx";

const accounting = require("accounting");

const NewLayout = ({ Table, Pagination, Filter, SettingsWrapper }) => (
  <div>
    <Table />
    <br />
    <Pagination />
  </div>
);

class CurrencyTable extends React.Component {
  //function ReportTable({ ...props }) {
  render() {
    let { classes, tableData, tableHeaderColor } = this.props;

    const styleConfig = {
      icons: {
        TableHeadingCell: {
          sortDescendingIcon: <div />,
          sortAscendingIcon: <div />,
        },
      },
      classNames: {
        Table: `${classes.table}`,
        TableHeadingCell: `${classes.tableHeadCell}`,
        TableHeading: `${classes[tableHeaderColor + "TableHeader"]}`,
        Cell: `${classes.tableCell}`,
        Row: `${classes.tableRow}`,
      },
    };

    const moneyCol = ({ value, griddleKey, money }) => {
      return <div>{accounting.formatMoney(value)}</div>;
    };

    const PercentCol = ({ value, griddleKey, tdata }) => {
      return <div>{Number.parseFloat(value).toFixed(1)}%</div>;
    };

    let tableKey = Math.floor(Math.random() * 100);

    return (
      <div>
        <CardBody>
          <div className={classes.tableContainer}>
            <Griddle
              data={tableData}
              plugins={[plugins.LocalPlugin]}
              key={tableKey}
              styleConfig={styleConfig}
              components={{
                Layout: NewLayout,
              }}
              pageProperties={{
                pageSize: 20,
              }}
            >
              <RowDefinition>
                <ColumnDefinition id="UNIT_ID" title="Cassette" />
                <ColumnDefinition
                  id="NOTE_VALUE"
                  title="Value"
                  customComponent={moneyCol}
                />
                <ColumnDefinition id="QUANTITIES" title="Count" />
                <ColumnDefinition
                  id="CAPACITY"
                  title="Capacity"
                  customComponent={PercentCol}
                />
                <ColumnDefinition
                  id="AMOUNT"
                  title="Total"
                  customComponent={moneyCol}
                />
              </RowDefinition>
            </Griddle>
          </div>
        </CardBody>
      </div>
    );
  }
}

CurrencyTable.defaultProps = {
  tableHeaderColor: "gray",
};

CurrencyTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "scmain",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.object),
};

export default withStyles(tableStyle)(CurrencyTable);



// WEBPACK FOOTER //
// ./src/components/Table/CurrencyTable.jsx